(function StartBooking($, HE)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		HE.onload(['/Reservations/cancelFromEmail/', '/Reservations/cancelFromBooking/'], function onload()
		{
			$('#cancel-agree').click(function _enableSubmit() {
				if ($(this).prop('checked') === true) {
					$('.cancel-booking').removeClass('disabled');
					$('.cancel-booking').prop('disabled', null);
				} else {
					$('.cancel-booking').addClass('disabled');
					$('.cancel-booking').prop('disabled', true);
				}
			});
		});
	});
}(jQuery, window.HE || {}));